// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmailForm__submit":"zh_a bhv_pp bhv_sk"};